import layout from './layout.vue'

export default layout
